// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectPortfolioSystemMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_PORTFOLIO_SYSTEM_MESSAGE);
        this.PortfolioManagerLogin = null; // PFixStringField FIELD_LOGIN = new PFixIntField(3); - логин Portfolio manager-a
        this.PortfolioSystemID = null; // PFixIntField FIELD_PORTFOLIO_SYSTEM_ID = new PFixIntField(727); - идентификатор портфолио системы
        this.PortfolioSystemName = null; // PFixStringField FIELD_NAME = new PFixIntField(22); - строковое название системы
        this.StatusOut = null; // PFixIntField FIELD_STATUS = new PFixIntField(708);
    }
}
